import { FC, memo, useEffect } from "react";
import { BUTTON_VARIANT, BUTTON_COLOR } from "../../../../types/coreButtonTypes";
import ModalBody from "../../../core-components/modal-box/modal-body/ModalBody";
import ModalFooter from "../../../core-components/modal-box/modal-footer/ModalFooter";
import ModalHeader from "../../../core-components/modal-box/modal-header/ModalHeader";
import ModalBoxCore from "../../../core-components/modal-box/ModalBoxCore";
import CoreButtons from "../../../core-components/button/CoreButtons";
import parse from "html-react-parser";
import "./confirmationModal.scss";

interface IConfirmationModalProps {
	className?: string;
	open: boolean;
	heading: string;
	description: string | React.ReactNode;
	buttonText: string;
	buttonColor?: BUTTON_COLOR;
	buttonLoading?: boolean;
	buttonTextCancel?: string;
	children?: React.ReactNode;
	onClose: () => void;
	onClickSave: () => void;
	onClickCancel?: () => void;
	onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
}

const ConfirmationModal: FC<IConfirmationModalProps> = ({
	className,
	open,
	heading,
	description,
	buttonText,
	buttonColor = BUTTON_COLOR.PRIMARY,
	buttonLoading,
	buttonTextCancel = "Cancel",
	onClose,
	onClickSave,
	onClickCancel,
	children,
}) => {
	useEffect(() => {
		if (!open) return;

		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === "Enter") {
				onClickSave();
			} else if (e.key === "Escape") {
				onClose();
			}
		};

		document.addEventListener("keydown", handleKeyDown);
		return () => document.removeEventListener("keydown", handleKeyDown);
	}, [open, onClickSave, onClose]);

	return (
		<ModalBoxCore className={`confirmationModal ${className ?? ""}`} open={open} onClose={onClose}>
			<ModalHeader modalHeaderText={heading} closeModal={onClose} />
			<ModalBody>
				<p>{typeof description === "string" ? parse(description) : description}</p>
				{children}
			</ModalBody>
			<ModalFooter
				className={"confirmationModalFooterBtn"}
				buttonText={buttonTextCancel}
				fullWidth
				coreBtnPill
				variant={BUTTON_VARIANT.CONTAINED}
				color={buttonColor}
				onclick={onClickCancel || onClose}
				modalFooterClassName={"confirmationModalFooter"}
			>
				<CoreButtons
					buttonText={buttonText}
					variant={BUTTON_VARIANT.CONTAINED}
					color={buttonColor}
					loading={buttonLoading}
					onclick={onClickSave}
					sx={{ textTransform: "none" }}
				/>
			</ModalFooter>
		</ModalBoxCore>
	);
};
export default memo(ConfirmationModal);
